import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BarChart3, ArrowRight } from "lucide-react";
import { fmtNum, fmtPct } from "@/lib/verizonSalesApi";
import { pctTone } from "./StoreLeaderboard";

export const VerizonSalesSnapshotCard = ({ fetcher, link, testId, storeTsp = "all", title = "Dealer Sales" }) => {
  const [s, setS] = useState(null);
  useEffect(() => { fetcher().then(setS).catch(() => setS(false)); }, [fetcher]);
  if (s === false || (s && s.stores.length === 0)) return null;
  const focus = s && storeTsp !== "all" ? s.stores.find((x) => x.door_tsp === storeTsp) : null;
  const t = focus ? { ...focus.metrics, stores: 1 } : s?.totals;
  const top = s ? [...(focus ? [focus] : s.stores)].sort((a, b) => (b.metrics.pacing_pct ?? -1) - (a.metrics.pacing_pct ?? -1)).slice(0, 3) : [];
  const stats = t ? [
    ["MTD Acts", fmtNum(t.current_acts)], ["Quota", fmtNum(t.current_quota)],
    ["Pacing", fmtPct(t.pacing_pct)], ["Upgrades", fmtNum(t.current_upgrades)],
  ] : [];
  return (
    <Card className="border-slate-200 border-l-4 border-l-teal" data-testid={testId}>
      <CardHeader className="pb-2 flex-row items-center justify-between">
        <CardTitle className="text-base flex items-center gap-2"><BarChart3 className="w-4 h-4 text-teal" /> {title}</CardTitle>
        {link && <Link to={link}><Button variant="ghost" size="sm" data-testid={`${testId}-view-btn`}>Full report <ArrowRight className="w-4 h-4 ml-1" /></Button></Link>}
      </CardHeader>
      <CardContent>
        {!s ? <div className="h-20 animate-pulse bg-slate-100 rounded-lg" /> : (
          <div className="grid md:grid-cols-2 gap-4">
            <div className="grid grid-cols-4 gap-2">
              {stats.map(([label, v]) => (
                <div key={label}><div className="text-[11px] uppercase text-slate-500">{label}</div><div className="text-xl font-heading font-bold text-navy">{v}</div></div>
              ))}
              <div className="col-span-4 text-[11px] text-slate-500">{t.stores} {t.stores === 1 ? "store" : "stores"} · data through {s.last_sync?.updated_through || "—"}</div>
            </div>
            <div className="space-y-1 text-xs">
              <div className="text-[11px] uppercase text-slate-500">Top pacing stores</div>
              {top.map((st, i) => (
                <div key={st.door_tsp} className="flex justify-between"><span className="truncate pr-2">{i + 1}. {st.location?.name?.replace("Total Wireless | ", "") || `${st.city}, ${st.state}`}</span><b className={pctTone(st.metrics.pacing_pct)}>{fmtPct(st.metrics.pacing_pct)}</b></div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
